/**
 * Discount Model
 * Data transformation for discount entities
 */

/**
 * Map discount from API/storage format to UI format
 */
export function mapDiscountFromApi(item = {}) {
  return {
    id: item.id,
    name: item.name || '',
    description: item.description || '',
    type: item.type || 'Promoção',
    value: item.value || '',
    code: item.code || '',
    finalDate: item.finalDate || null,
    active: item.active !== false,
    finished: item.finished || false,
    createdAt: item.createdAt || new Date().toISOString(),
    updatedAt: item.updatedAt || new Date().toISOString(),
  };
}

/**
 * Build discount payload for API
 */
export function buildDiscountPayload(formData) {
  return {
    name: formData.name?.trim() || '',
    description: formData.description?.trim() || '',
    type: formData.type || 'Promoção',
    value: formData.value || '',
    code: formData.code?.trim() || '',
    finalDate: formData.finalDate || null,
    active: formData.active !== false,
  };
}

/**
 * Validate discount form data
 */
export function validateDiscountForm(formData) {
  const errors = {};

  if (!formData.name?.trim()) {
    errors.name = 'Nome é obrigatório';
  }

  if (!formData.type) {
    errors.type = 'Tipo é obrigatório';
  }

  if (!formData.value || formData.value <= 0) {
    errors.value = 'Valor deve ser maior que zero';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}

export default {
  mapDiscountFromApi,
  buildDiscountPayload,
  validateDiscountForm,
};
